// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"RP-z","inlineTitle":"SP-z","sponsoredAdsWrapper":"TP-z","marketplaceRecosWrapper":"UP-z"};